const columns = [
    {
        dataField: 'shipment_id',
        text: 'Shipment ID',
        type: 'entity',
        entityType: 'shipment',
        hideable: false,
        sort: true,
        headerStyle: {
            width: '80px',
        },
        localizationSlug: 'SHIPMENT_ID',
        formatExtraData: {
            showPreNoticeBadge: true
        }
    },
    {
        dataField: 'carrier_name',
        text: 'Carrier',
        hideable: false,
        sort: false,
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'CARRIER',
    },
    {
        dataField: 'status',
        text: 'Status',
        type: 'status',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '100px',
        },
        localizationSlug: 'STATUS',
    },
    {
        dataField: 'reference_numbers',
        text: 'Reference Numbers',
        type: 'reference_number',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'REFERENCE_NUMBERS',
    },
    {
        dataField: 'pickup',
        text: 'Pickup',
        type: 'daterange',
        hideable: true,
        sort: true,
        formatExtraData: {
            type: 'pickup',
        },
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'PICKUP',
    },
    {
        dataField: 'deliver',
        text: 'Deliver',
        type: 'daterange',
        hideable: true,
        sort: true,
        formatExtraData: {
            type: 'deliver',
        },
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'DELIVER',
    },
    {
        dataField: 'origin[0]',
        text: 'Origin',
        type: 'location',
        sort: true,
        hideable: true,
        headerStyle: {
            width: '150px',
        },
        localizationSlug: 'ORIGIN',
    },
    {
        dataField: 'destination[0]',
        text: 'Destination',
        type: 'location',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '150px',
        },
        localizationSlug: 'DESTINATION',
    },
    {
        dataField: 'driver_name',
        text: 'Driver',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '150px',
        },
        localizationSlug: 'DRIVER',
    },
    {
        dataField: 'loads',
        text: 'Load',
        type: 'loaddetails',
        sort: true,
        hideable: true,
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'LOAD',
    },
    {
        dataField: 'total_payable_rate',
        text: 'Carrier Payout',
        type: 'carrier_payout',
        hideable: true,
        sort: false,
        headerStyle: {
            width: '80px',
        },
        localizationSlug: 'CARRIER_PAYOUT',
    },
    {
        dataField: 'missing_docs',
        text: 'Missing POD',
        type: 'boolean',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '100px',
        },
        localizationSlug: 'MISSING_POD',
    },
    {
        dataField: 'actual_progress_percentage',
        text: 'Progress',
        type: 'sla',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '120px',
        },
        localizationSlug: 'PROGRESS',
    },
    {
        dataField: 'reference_numbers',
        text: 'Equipments',
        type: 'equipments',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '150px',
        },
        localizationSlug: 'EQUIPMENT',
    },
    {
        dataField: 'documents',
        text: 'Documents',
        type: 'documents',
        hideable: true,
        sort: true,
        headerStyle: {
            width: '150px',
        },
        localizationSlug: 'DOCUMENTS',
    },
];
export default {
    columns,
};
